import React, { useState, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import { useAuth } from "../../components/AuthProvider";
import Logo from "../../components/logo/Logo";
import InputField from "../../components/inputField/InputField";
import Button from "../../components/button/Button";
import './LoginPage.css';
import Footer from "../../components/footer/Footer";
import Message from "../../components/message/Message";
import { getCountryCodes } from "../../services/firebase/Firebase";
import CountryCodeSelector from "../../components/countrySelector/CountryCodeSelector";
import { mapCountryFlag } from "../../utils/utils";

const LoginPage = () => {
    const [codeCompany, setCodeCompany] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [fullName, setFullName] = useState("");
    const [message, setMessage] = useState(null);
    const [isRegistering, setIsRegistering] = useState(false);
    const [countryCodes, setCountryCodes] = useState(null);
    const [selectedCountryCode, setSelectedCountryCode] = useState('co');

    const { loginAction, registerAction, loadingSuccess } = useAuth();

    useEffect(() => {
        async function fetchData() {
          try {
            const data = await getCountryCodes();
            const countriesActiveWithMappedCode = data.filter((country) => country.active).map(country => ({
                ...country,
                mappedFlag: mapCountryFlag(country.flag)
            }));
            setCountryCodes(countriesActiveWithMappedCode);
            if (countriesActiveWithMappedCode && countriesActiveWithMappedCode.length > 0) {
                setSelectedCountryCode(countriesActiveWithMappedCode[0].code);
            }
          } catch (error) {
            console.error("Error fetching data:", error);
          }
        }
        fetchData();
      }, []);

    const handleLoginOrRegister = async (e) => {
        e.preventDefault();
        const specialCharRegex = /[^0-9]/g;

        if (specialCharRegex.test(codeCompany)) {
            setMessage({ text: 'Por favor, ingresa solo números en el código de empresa', type: 'warning' });
            return;
        }
        if (specialCharRegex.test(phoneNumber)) {
            setMessage({ text: 'Por favor, ingresa solo números en el numero de celular', type: 'warning' });
            return;
        }

        const baseRequestBody = {
            tradingPartnerId: codeCompany,
            tradingPartnerPhone: selectedCountryCode+phoneNumber,
        };

        if (isRegistering) {
            const registerRequestBody = { ...baseRequestBody, driverFullName: fullName };
            try {
                const response = await registerAction(registerRequestBody);
                if (response && response.status === 200) {
                    //navigate('/'); // Redirigir al home después del registro exitoso
                } else if (response && response.status === 400) {
                    setMessage({ text: "El usuario ya se encuentra registrado", type: "warning" });
                    setIsRegistering(true);
                } else {
                    setMessage({ text: "Error al realizar el registro. Inténtalo de nuevo.", type: "error" });
                    setIsRegistering(true);
                }
            } catch (error) {
                setMessage({ text: "Error al registrar. Inténtalo de nuevo.", type: "error" });
            }
        } else {
            try {
                const response = await loginAction(baseRequestBody);
                if (response && response.status === 200) {
                    //navigate('/'); // Redirigir al home después del login exitoso
                } else if (response && response.status === 404) {
                    setMessage({ text: "Usuario no encontrado. Ingresa tu nombre completo para registrarte.", type: "warning" });
                    setIsRegistering(true);
                } else if (response && response.status === 400) {
                    setMessage({ text: "El usuario ya se encuentra registrado", type: "warning" });
                    setIsRegistering(true);
                } else {
                    setMessage({ text: "Error al iniciar sesión. Inténtalo de nuevo.", type: "error" });
                }
            } catch (error) {
                setMessage({ text: "Error al iniciar sesión. Inténtalo de nuevo.", type: "error" });
            }
        }
    };

    const handleCloseMessage = () => {
        setMessage(null);
    };

    const handleCodeCompanyChange = (e) => {
        const value = e.target.value;
        if (value.length <= 10 || value === "") {
            setCodeCompany(value);
        }
    };

    const handlePhoneNumberChange = (e) => {
        const value = e.target.value;
        if (value.length <= 10 || value === "") {
            setPhoneNumber(value);
        }
    };

    const handleCountryCodeChange = (value) => {
        setSelectedCountryCode(value);
    };

    const isLoginFormValid = codeCompany.trim() !== "" && phoneNumber.trim() !== "" && phoneNumber.length === 10 && codeCompany.length <= 10;
    const isRegisterFormValid = isLoginFormValid && fullName.trim() !== "";
    const isFormValid = isRegistering ? isRegisterFormValid : isLoginFormValid;
    const buttonText = isRegistering ? "REGISTRAR" : "CONTINUAR";

    return (
        <div className="login-page-container">
            <div className="login-logo-container">
                <Logo />
            </div>
            <div className="login-form-container">
                <form onSubmit={handleLoginOrRegister}>
                    <div>
                        <div>
                            <h3 className="title-login">Inicio de sesión</h3>
                        </div>
                        <div>
                            {isRegistering && (
                                <h5 className="subtitle-login">PASO 2 : COMPLEMENTA TUS DATOS</h5>
                            )}
                            {isRegistering === false && (
                                <h5 className="subtitle-login">PASO 1 : INGRESA TUS DATOS</h5>
                            )}
                        </div>
                        <div className="container-inputs">
                            {isRegistering && (
                                <div>
                                    <InputField
                                        placeholder="NOMBRE COMPLETO"
                                        maxLength="50"
                                        type="text"
                                        onChange={(e) => setFullName(e.target.value)}
                                        value={fullName}                                    
                                    />
                                </div>
                            )}                        
                            <div>
                                <InputField
                                    placeholder="CÓDIGO DE EMPRESA"
                                    maxLength="10"
                                    type="number"
                                    onChange={handleCodeCompanyChange}
                                    value={codeCompany}                                
                                />
                            </div>
                            <div className="phone-container">                            
                                {countryCodes && (
                                    <div className="country-code-wrapper">
                                        <CountryCodeSelector
                                            countryCodes={countryCodes}
                                            onCountryCodeChange={handleCountryCodeChange}
                                            initialCountryCode={countryCodes[0]?.code}
                                        />
                                    </div>
                                )}
                                <InputField
                                    placeholder="NÚMERO DE CELULAR"
                                    maxLength="12"
                                    type="number"
                                    onChange={handlePhoneNumberChange}
                                    value={phoneNumber}
                                    className="phone-number-input"
                                />
                            </div>
                        </div>
                        {message && (
                            <div className="message-container">
                                <Message text={message.text} type={message.type} onClose={handleCloseMessage} />
                            </div>
                        )}
                        <div>
                        <Button type="submit" disabled={loadingSuccess || !isFormValid}>
                            {loadingSuccess ? <CircularProgress size={24} /> : buttonText}
                        </Button>
                        </div>
                    </div>
                </form>
            </div>
            <Footer/>
        </div>
    );
};

export default LoginPage;